import { useContext } from "react";

import ThemeContext from "../../../Products/context";

export default function useGetRedirect() {
	const { state } = useContext(ThemeContext);

	const redirectUrl = () => `${state.redirectUri}?&entity=${state.entity?.id}&finished_by=SUCCESS`;

	const onClickRedirect = () => {
		window.location.href = redirectUrl();
	};

	return { onClickRedirect };
}
